import { MeasureLayout } from '../../motion/features/layout/Measure.js';
import { createMotionProxy } from './motion-proxy.js';

/**
 * @public
 */
var m = createMotionProxy([MeasureLayout]);

export { m };
